/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const updateItemStatusRequestSchema = z.object({
  afterId: z.int().nullish(),
  beforeId: z.int().nullish(),
  color: z.string(),
  default: z.boolean().nullish(),
  name: z.string(),
  schedulingType: z.enum(['IN_PROGRESS', 'TO_DO', 'DONE']),
});
